<template>
  <div>
    <page-header title="Перевозка квадрациклов"/>
    <div class="public-container public-container-mobile shipping-types">
      <div id="about" class="shipping-types-banner-wrapper">
        <div class="shipping-types-banner mb-30">
          <public-card-info img-url="/images/pages/shipping-type/quad-bike.png">
            <div class="shipping-types-card-text">
              {{ content.blocks?.about.cardText }}
            </div>
          </public-card-info>

          <public-card-attention class="mt-30">
            <template #append>
              <div class="quad-bike-attention vz-text-align-left">
                <vz-icon
                    url="/svg/wrapping-box.svg"
                    variant="white"
                    no-masked-icon
                    size="56"
                />
                <p class="quad-bike-attention-title">{{ content.blocks?.about.attentionTitle }}</p>
              </div>
              <p class="vz-text-align-left mt-20">{{ content.blocks?.about.attentionText }}</p>
            </template>
          </public-card-attention>
        </div>

        <div>
          <p>{{ content.blocks?.about.description }}</p>
        </div>
      </div>

      <div class="shipping-types-block">
        <div v-for="item in items" class="shipping-types-info-item">
          <vz-icon
            :url="item.icon"
            variant="primary"
            no-masked-icon
          />
          <div>
            <div class="shipping-types-info-item-title">{{ item.title }}</div>
            <div v-html="item.text" />
            <public-text-warning v-if="item.warning">
              {{ item.warning }}
            </public-text-warning>
          </div>
        </div>
      </div>

      <div id="transport" class="shipping-types-block mb-90">
        <h2 class="vz-text-align-left">{{ content.blocks?.transport.title }}</h2>
        <ul class="public-list public-list-square">
          <li v-for="text in content.blocks?.transport.list.split(';')">
            <span>{{ text }}</span>
          </li>
        </ul>
      </div>

      <shipping-types-buttons />

      <shipping-types-faq :items="quadBikeFaq" />

      <shipping-types-chain current="quad-bike" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import PublicCardAttention from '~/components/public/public-card-attention.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import ShippingTypesFaq from '~/components/public/shipping-types/shipping-types-faq.vue'
import PublicTextWarning from '~/components/public/public-text-warning.vue'
import { quadBikeFaq } from '~/common/public/shipping-types-faq'
import { getPageContent } from '~/api/content';

const content = await getPageContent('/shippingtypes/quad-bike')

const items = computed(() => [
  {
    icon: '/svg/icon/vz-home.svg',
    title: content.blocks?.about.addressDeliveryTitle,
    text: content.blocks?.about.addressText,
  },
  {
    icon: '/svg/shield.svg',
    title: content.blocks?.about.insuranceTitle,
    text: content.blocks?.about.insuranceText,
  },
  {
    icon: '/svg/crane.svg',
    title: content.blocks?.about.transportTitle,
    text: content.blocks?.about.transportText,
  },
  {
    icon: '/svg/box-transportation.svg',
    title: content.blocks?.about.pprTitle,
    text: content.blocks?.about.pprText,
    warning: content.blocks?.about.attention,
  },
])
</script>

<style lang="scss" scoped>
.quad-bike-attention {
  display: flex;
  gap: 20px;
  font-size: 24px;
  line-height: 30px;
  padding-right: 5px;

  @media screen and ($pub-sm >= width > $pub-xs) {
    flex-wrap: wrap;
  }
}
</style>
